import { Component, Input, Output, EventEmitter } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-manage-supplier-game',
  templateUrl: './manage-supplier-game.component.html',
  styleUrls: ['./manage-supplier-game.component.scss']
})
export class ManageSupplierGameComponent {


  @Input() company_uuid;
  @Output() closeEvent = new EventEmitter<void>();
  public games:any = []
  public _games:any = []
  public loading:boolean = false;
  private filter = {
    supplier: null,
    name: null,
    type: null
  };

  // "Images" tab — full supplier_game catalog (incl. platforms not enabled as tiles,
  // e.g. Playtech) so staff can upload art for games missing an image.
  public mode: 'disable' | 'images' = 'disable';
  public imgGames:any = [];
  public imgLoading:boolean = false;
  public imgPage:number = 1;
  public imgTotal:number = 0;
  public imgTotalPages:number = 0;
  public imgFilter = { platform: '', name: '', category: '', missing: false };
  private imgSearchTimer:any = null;

  constructor(private http: HttpService) {
    this.getAvailableGames();
  }

  setMode(m: 'disable' | 'images') {
    this.mode = m;
    if (m === 'images' && this.imgGames.length === 0) {
      this.loadImages(true);
    }
  }

  async loadImages(resetPage: boolean = false) {
    if (resetPage) this.imgPage = 1;
    this.imgLoading = true;
    try {
      const rtn: any = await this.http.post('/admin/app/supplier-game/list', {
        platform: this.imgFilter.platform || null,
        name: this.imgFilter.name || null,
        category: this.imgFilter.category || null,
        missing_image: this.imgFilter.missing ? 1 : null,
        page: this.imgPage
      });
      if (rtn && rtn.status) {
        this.imgGames = rtn.rows || [];
        this.imgTotal = rtn.total || 0;
        this.imgTotalPages = rtn.total_pages || 0;
      }
    } finally {
      this.imgLoading = false;
    }
  }

  // debounce free-text search boxes
  searchImages() {
    if (this.imgSearchTimer) clearTimeout(this.imgSearchTimer);
    this.imgSearchTimer = setTimeout(() => this.loadImages(true), 400);
  }

  imgPrev() { if (this.imgPage > 1) { this.imgPage--; this.loadImages(); } }
  imgNext() { if (this.imgPage < this.imgTotalPages) { this.imgPage++; this.loadImages(); } }
  imgSize() { return 50; }

  async getAvailableGames() {
    this.loading = true;
    let games = await this.http.post('/admin/app/skip-game/available/get');
    this._games = games;
    this.games = games;
    this.loading = false;
  }

  searchSupplier(event: any) {
    this.filter.supplier = event.target.value;
    this.filterGames();
  }

  searchName(event: any) {
    this.filter.name = event.target.value
    this.filterGames();
  }
  
  searchType(event: any) {
    this.filter.type = event.target.value
    this.filterGames();
  }
  
  filterGames() {

    if(!this.filter.name && !this.filter.type && !this.filter.supplier) {
      this.games = this._games;
      return;
    }

    this.games = this._games.filter((v:any) => {
      let name = this.filter.name && v.name ? v.name.toLowerCase().includes(this.filter.name.toLowerCase()) : true;
      let type = this.filter.type && v.category ? v.category.toLowerCase().includes(this.filter.type.toLowerCase()) : true;
      let supplier = this.filter.supplier && v.platform ? v.platform.toLowerCase().includes(this.filter.supplier.toLowerCase()) : true;
      return name && type && supplier && v.name && v.category && v.platform;
    })
  }

  // Read a picked file into a base64 data URL (accepts any image/* incl. webp),
  // mirroring the SA supplier-game upload rather than the stricter shared helper.
  private toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => resolve(e.target.result);
      reader.onerror = () => reject(new Error('Failed to read file'));
      reader.readAsDataURL(file);
    });
  }

  async uploadImage(event: any, game: any) {
    const file = event.target && event.target.files ? event.target.files[0] : null;
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      this.http.notify('Image too large (max 5MB).');
      event.target.value = '';
      return;
    }

    game.uploading = true;
    try {
      const base64 = await this.toBase64(file);
      const rtn: any = await this.http.post('/admin/app/supplier-game/image/upload', {
        image: base64,
        platform: game.platform,
        game_id: game.game_code,
        supplier_game_id: game.id
      });

      if (rtn && rtn.status) {
        // cache-bust so the freshly uploaded art shows immediately
        game.image = rtn.image + '?t=' + (new Date()).getTime();
        this.http.notify('Image uploaded successfully.');
      } else {
        this.http.notify((rtn && rtn.message) || 'Upload failed.');
      }
    } catch (e: any) {
      this.http.notify('Upload error: ' + (e && e.message ? e.message : e));
    } finally {
      game.uploading = false;
      if (event.target) event.target.value = '';
    }
  }

  gameChecked(game:any) {
    let game_id = game.id;
    let game_index = this._games.findIndex((v:any) => v.id == game_id);

    this._games[game_index].checked = !this._games[game_index].checked;

    if(this._games[game_index].checked) {
      this._games[game_index].animate = true;
    } else {
      this._games[game_index].animate = null;
    }
  }

  animateChecked(game:any) {
    let game_id = game.id;
    let game_index = this._games.findIndex((v:any) => v.id == game_id);

    this._games[game_index].animate = !this._games[game_index].animate;
  }

  async save() {
    let games = this._games.filter((v:any) => v.checked); 

    let rtn:any = await this.http.post('/admin/app/skip-game/save', {games});
    
    if(rtn.status) {
      this.http.notify("Game disable updated successfully.");
    }

  }

}
